export class TipoLiquidato {

  id: string;
  descrizione: string;
  rimosso: boolean;
  label: string;
}
